var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img_wtapper"},[_c('el-image',{staticClass:"home_img",attrs:{"src":"https://wugecdn.steam.fun/resources/static/m_homepage/m_home.png","fit":"fill"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }